/* Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial */
export function staffInviteTarget(relative: string, admin: string): string {
  const origin = new URL(admin).origin;
  const target = new URL(relative, origin);
  if (
    target.origin !== origin ||
    !["https:", "http:"].includes(target.protocol)
  )
    throw new Error("Invalid cabinet destination");
  return target.href;
}
/** No credentials cross origins: the cabinet reports only verified availability. */
export async function discoverStaffSession(
  admin: string,
  signal: AbortSignal,
): Promise<boolean> {
  const origin = new URL(admin).origin;
  return new Promise((resolve) => {
    if (signal.aborted) {
      resolve(false);
      return;
    }
    const nonce = crypto.randomUUID(),
      frame = document.createElement("iframe");
    frame.hidden = true;
    frame.title = "Account session";
    frame.src = origin + "/auth/staff-bridge";
    const finish = (available: boolean): void => {
      clearTimeout(timer);
      window.removeEventListener("message", message);
      signal.removeEventListener("abort", abort);
      frame.remove();
      resolve(available);
    };
    const abort = (): void => finish(false);
    const hello = (): void =>
      frame.contentWindow?.postMessage(
        { type: "call-staff-check", nonce },
        origin,
      );
    const message = (event: MessageEvent): void => {
      if (event.origin !== origin || event.source !== frame.contentWindow)
        return;
      if (event.data?.type === "call-staff-ready") {
        hello();
        return;
      }
      if (
        event.data?.type === "call-staff-result" &&
        event.data.nonce === nonce
      )
        finish(event.data.available === true);
    };
    const timer = setTimeout(() => finish(false), 5000);
    window.addEventListener("message", message);
    signal.addEventListener("abort", abort, { once: true });
    frame.onload = hello;
    document.body.append(frame);
  });
}

export function openStaffInvite(relative: string, admin: string): void {
  window.location.replace(staffInviteTarget(relative, admin));
}
